const React = require('react');
// import FormattedMessage from '@/intl/formatted-message';
import { formatMessage } from '../../intl/helper';
import dishMenuMessages from '../../intl/messages/dish-menu';
import shoppingCartMessage from '../../intl/messages/shopping-cart';
import commonText from '../../intl/messages/common';
const BtnShortcutDefault = require('./btn-shortcut-default.jsx');
import shortcutCloseIcon from '../../asset/images/dish-zc-fastnavi/navi-close.svg';
const config = require('../../config');
import { getTableInfoInSessionStorage, overWriteSessionStorage } from '../../helper/order-dinner-cart-helper';
import { getUrlParam } from '../../helper/common-helper';
import iParkHelper from '../../helper/iPark/iParkHelper';
import ccbAppHelper from '../../helper/Ccb-app-helper';
import naviCenterIcon from '../../asset/images/dish-zc-fastnavi/navi-center.svg';
import naviCouponIcon from '../../asset/images/dish-zc-fastnavi/navi-coupon.svg';
import naviDishmenuIcon from '../../asset/images/dish-zc-fastnavi/navi-dishmenu.svg';
import naviOrdercartIcon from '../../asset/images/dish-zc-fastnavi/navi-ordercart.svg';
import naviOrderedIcon from '../../asset/images/dish-zc-fastnavi/navi-ordered.svg';
import naviPayIcon from '../../asset/images/dish-zc-fastnavi/navi-pay.svg';
import naviBellIcon from '../../asset/images/dish-zc-fastnavi/navi-serverbell.svg';
import prepaidCodeIcon from '../../asset/images/dish-zc-fastnavi/prepaid-code.svg';
import classnames from 'classnames';

const shopId = getUrlParam('shopId');
const isIParkEnv = iParkHelper.isIParkEvn();

const BtnShortcutMulti = React.createClass({
  displayName: 'BtnShortcutMulti',
  propTypes: {
    btnAttributesMulti: React.PropTypes.object,
    orderId: React.PropTypes.oneOfType([React.PropTypes.number, React.PropTypes.string]),
    tableId: React.PropTypes.oneOfType([React.PropTypes.number, React.PropTypes.string]),
    isNavi: React.PropTypes.bool,
  },

  getInitialState() {
    return {
      isChildrenShow: false,
      mainBtnAttributes: this.props.btnAttributesMulti.btnAttributesMain || {},
    };
  },

  componentDidMount() {
    document.body.addEventListener('touchstart', this.handleOtherTouch);
  },

  componentWillReceiveProps(nextProps) {
    const { btnAttributesMulti = {}, isChildrenShowProp } = nextProps;
    this.setState(
      {
        mainBtnAttributes: btnAttributesMulti.btnAttributesMain || {},
        isChildrenShow: isChildrenShowProp,
      },
      () => {
        setTimeout(() => {
          this.setState({ isAddTransition: isChildrenShowProp });
        }, 0);
      },
    );
    if (isChildrenShowProp) {
      this.setState({
        mainBtnAttributes: {
          icon: shortcutCloseIcon,
          text: '',
          iconWidth: '13px',
          onClick: this.clickMethod,
        },
      });
    }
  },

  clickMethod() {
    const {
      isChildrenShowProp,
      btnAttributesMulti: { btnAttributesMain = {} },
    } = this.props;
    const { onClick: clickMethod } = btnAttributesMain;
    this.setState({ isAddTransition: !isChildrenShowProp }, () => {
      if (clickMethod) {
        setTimeout(() => {
          clickMethod();
        }, 200);
      }
    });
  },

  componentWillUnmount() {
    document.body.removeEventListener('touchstart', this.handleOtherTouch);
  },

  getBtnChildren(btnAttributesMulti = {}, orderId, tableId) {
    const { isNavi, refreshServiceStatus, shopMinConsume, fromOrderDinnerStatement } = this.props;
    const isPayFirst = sessionStorage.getItem('diningForm') === '2';
    const tableParam = tableId ? `&tableId=${tableId}` : '';
    const orderParam = orderId ? `&orderId=${orderId}` : '';
    const hasShopMinConsume = isPayFirst && shopMinConsume && shopMinConsume.state === 1;
    const isCcbEnv = ccbAppHelper.isCcbEvn();

    const overwriteTableInfo = () => {
      overWriteSessionStorage(shopId, {
        tableId,
        orderId,
      });
    };

    const btnChildrenArray = [];
    let btnChildrenTemp = [];
    const defaultChildren = [
      {
        text: formatMessage(shoppingCartMessage.mineCoupons),
        childIcon: naviCouponIcon,
        onClick: () => {
          overwriteTableInfo();
          location.href = `${config.getCouponListURL}?shopId=${shopId}&isShowShortcut=true`;
        },
      },
      {
        text: formatMessage(shoppingCartMessage.checkoutMoney),
        childIcon: naviPayIcon,
        onClick: () => {
          if (refreshServiceStatus) {
            refreshServiceStatus({ tableId, orderId }).then((res = {}) => {
              if (res.addDishUnhandle) {
                this.props.setErrorMsg(formatMessage(commonText.commoncannotPay));
                return;
              }

              location.href = `${config.settlement4DinnerURL}?shopId=${shopId}&tradeId=${orderId}&type=TS`;
            });
            return;
          }

          location.href = `${config.settlement4DinnerURL}?shopId=${shopId}&tradeId=${orderId}&type=TS`;
        },
      },
      {
        text: formatMessage(shoppingCartMessage.placedOrder),
        childIcon: naviOrderedIcon,
        onClick: () => {
          location.href = `${config.tradeDetailUncheckURL}?shopId=${shopId}&orderId=${orderId}&type=TS`;
        },
      },
      {
        text: formatMessage(shoppingCartMessage.title),
        childIcon: naviOrdercartIcon,
        onClick: () => {
          overwriteTableInfo();
          location.href = `${isPayFirst ? config.dishCart4DinnerPayFirst : config.dishCart4DinnerURL}?shopId=${shopId}&type=TS`;
        },
      },
      {
        text: formatMessage(dishMenuMessages.navigatorDishList),
        childIcon: naviDishmenuIcon,
        onClick: () => {
          location.href = `${config.dishMenu4DinnerURL}?shopId=${shopId}&type=TS&addDishes=true${tableParam}${orderParam}`;
        },
      },
    ];

    if (!isIParkEnv) {
      defaultChildren.unshift({
        text: formatMessage(dishMenuMessages.navigatorMeCenter),
        childIcon: naviCenterIcon,
        onClick: () => {
          overwriteTableInfo();
          location.href = `${config.mineIndexURL}?shopId=${shopId}&isShowShortcut=true`;
          sessionStorage.setItem('isShowShortcut', true);
        },
      });
    }

    // 有最低消费，将菜单换成验证预付单
    if (hasShopMinConsume) {
      defaultChildren.pop();
      defaultChildren.push({
        text: '验证预付单',
        childIcon: prepaidCodeIcon,
        onClick: () => {
          const returnUrl = encodeURIComponent(window.location.href);
          let href = `${config.prepaidCodeUrl}?shopId=${shopId}&returnUrl=${returnUrl}`;
          if (fromOrderDinnerStatement) {
            href = `${href}&orderId=${orderId}`;
          }
          location.href = href;
        },
      });
    }
    // 添加服务铃
    if (this.props.bell) {
      defaultChildren.push({
        text: formatMessage(dishMenuMessages.serviceBell),
        childIcon: naviBellIcon,
        onClick: () => {
          //
        },
      });
    }

    if (btnAttributesMulti) {
      if (btnAttributesMulti.btnChildren && btnAttributesMulti.btnChildren.length > 0) {
        btnChildrenTemp = btnAttributesMulti.btnChildren;
      } else {
        btnChildrenTemp = defaultChildren;
      }

      if (btnAttributesMulti.btnDisable && btnAttributesMulti.btnDisable.length > 0) {
        for (let i = 0; i < btnAttributesMulti.btnDisable.length; i++) {
          if (typeof btnAttributesMulti.btnDisable[i] === 'number') {
            btnChildrenTemp[btnAttributesMulti.btnDisable[i] - 1].onClick = () => {};
            btnChildrenTemp[btnAttributesMulti.btnDisable[i] - 1].classnames = 'btn-shortcut-disable';
          }
        }
      }
      for (let i = 0; i < btnChildrenTemp.length; i++) {
        const { btnAttributesDefault = {} } = btnAttributesMulti;
        const { expandClassNames } = btnAttributesDefault;
        const { text = '' } = btnChildrenTemp[i];
        // 建行环境屏蔽个人中心和优惠券入口
        const isNotShowBtn = text === formatMessage(shoppingCartMessage.mineCoupons) || text === formatMessage(dishMenuMessages.navigatorMeCenter);
        if (isNotShowBtn && isCcbEnv) continue;

        let btnChild = (
          <BtnShortcutDefault
            key={i}
            btnAttributes={Object.assign({}, btnAttributesDefault, btnChildrenTemp[i], expandClassNames && !isNavi ? { classnames: expandClassNames } : {})}
            isNavi={isNavi}
          />
        );
        // 服务铃的处理
        if (text === formatMessage(dishMenuMessages.serviceBell)) {
          btnChild = (
            <BtnShortcutDefault
              key={i}
              btnAttributes={Object.assign({}, btnAttributesDefault, btnChildrenTemp[i], expandClassNames && !isNavi ? { classnames: expandClassNames } : {})}
              isNavi={isNavi}
              bell={this.props.bell}
            />
          );
        }
        btnChildrenArray.push(btnChild);
      }
    }

    return btnChildrenArray;
  },

  handleOtherTouch(evt) {
    const { target } = evt;
    const { isChildrenShow } = this.state;

    if (!isChildrenShow || this.refs.wrapper.contains(target)) {
      return;
    }

    const { mainBtnAttributes } = this.state;
    if (mainBtnAttributes.onClick) {
      mainBtnAttributes.onClick();
    }
  },

  render() {
    const { btnAttributesMulti, orderId, tableId, isNavi } = this.props;
    const { isChildrenShow, isAddTransition, mainBtnAttributes } = this.state;
    const { btnAttributesDefault } = btnAttributesMulti;
    return (
      <div ref="wrapper" className={`shortcut-multi btn-shortcut-${btnAttributesDefault && btnAttributesDefault.size}`}>
        {isChildrenShow && (
          <div className={classnames('shortcut-multi-children', { 'shortcut-multi-children--navi': isNavi })}>
            <div
              className={classnames('shortcut-multi-children__hover', {
                'shortcut-multi-children__hover--enter': isAddTransition,
                'shortcut-multi-children__hover--disable': !isNavi,
              })}
              onTouchTap={this.clickMethod}
            />
            <div className={classnames('o-flex shortcut-multi-children__body', { 'shortcut-multi-children__body--enter': isAddTransition })}>
              {this.getBtnChildren(
                btnAttributesMulti,
                orderId || getTableInfoInSessionStorage(shopId).orderId,
                tableId || getTableInfoInSessionStorage(shopId).tableId,
              )}
            </div>
          </div>
        )}
        <BtnShortcutDefault mainButton isChildrenShow={isChildrenShow} btnAttributes={Object.assign({}, btnAttributesDefault, mainBtnAttributes)} />
      </div>
    );
  },
});

module.exports = BtnShortcutMulti;



// WEBPACK FOOTER //
// ./src/component/common/btn-shortcut-multi.jsx